// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"0f79832e6f0dfcc06509","147":"3711174d6e781ac67e99","251":"99d8d075693b33ed5e8c","352":"d96dda2632834d98f03f","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};